import { useState } from 'react';
import { useField } from '@tanstack/react-form';
import { Box, Grid, IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';
import { AssetsDialog } from 'src/components/pickem-admin/AssetsDialog';

export const UploadImage = (props: any & { label: string }) => {
  const field = useField(props);

  const [assetsTarget, setAssetsTarget] = useState<string>('');

  const deleteImage = () => {
    field.handleChange('');
  };

  const onChoseAsset = (assetUrl: string) => {
    field.handleChange(assetUrl);
    setAssetsTarget('');
  };

  const onCloseAssetsDialog = () => {
    setAssetsTarget('');
  };

  return (
    <Grid item xs={4}>
      <Box>
        {props.label} {props.required && '*'}
      </Box>
      {field.state.value !== '' ? (
        <Box sx={{ display: 'flex', mt: 1 }}>
          <img
            style={{
              margin: '0 auto',
              width: 100,
              background: 'grey',
            }}
            alt=''
            src={field.state.value as string}
          />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={() => setAssetsTarget(props.name)}>
              <Iconify icon='eva:edit-outline' />
            </IconButton>
            <IconButton onClick={() => deleteImage()}>
              <Iconify icon='eva:close-outline' />
            </IconButton>
          </Box>
        </Box>
      ) : (
        <IconButton onClick={() => setAssetsTarget(props.name)}>
          <Iconify icon='eva:plus-circle-outline' />
        </IconButton>
      )}

      <AssetsDialog
        open={Boolean(assetsTarget)}
        onSuccess={onChoseAsset}
        onClose={onCloseAssetsDialog}
      />
    </Grid>
  );
};
